import type { Static } from 'runtypes';
import { Literal, Record, String } from 'runtypes';
import { CoreEventRuntype } from './core';
import { ClickstreamEventEnum } from 'bc-model';

const SessionInitiatedEventRuntype = CoreEventRuntype.And(
  Record({
    sessionId: String,
    event: Literal(ClickstreamEventEnum.SESSION_INITIATED),
    version: Literal(1),
  })
);

type SessionInitiatedEvent = Static<typeof SessionInitiatedEventRuntype>;

export { SessionInitiatedEventRuntype, type SessionInitiatedEvent };
